import React from "react";
import "./wmswitch.css";
function Wmswitch({color,onChange,checked}) {
  return (
    <label className={`switch`}>
      <input type="checkbox" checked = {checked}  className={`${color}`} onChange={onChange}/>
      <span className="slider round"></span>
    </label>
  );
}

export default Wmswitch;
